import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=783f2a2c&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=783f2a2c&prod&lang=scss&scoped=true"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=783f2a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783f2a2c",
  null
  
)

export default component.exports